
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout 		= APP.module('Layout');
	var View 		= APP.module('View');

	Layout.Sidebar = Marionette.LayoutView.extend({
		template: JST.Sidebar,
		regions: {
			widgets: "#sidebar-widgets"
		},
		initialize: function(){
			this.model = new Backbone.Model();
			this.model.set('widgets', []);
			this.listenTo(this.model, 'change:widgets', this.render);

			return this;
		},
		onShow: function() {
			var widgets_list    = this.getOption('widgets_list'),
				//TODO:: Try to add option only for current widget
				widgets_options = this.getOption('widgets_options') || {};

			_.each(widgets_list, function(widgetName){
				var regionId = this.addWidgetRegion();
				this.addRegion(regionId, "#" + regionId);

				setTimeout(_.bind(function(){
					if (this.getRegion(regionId)) {
						try{
							this.getRegion(regionId).show(new View[widgetName](widgets_options));
						} catch(err) {
							console.error(err);
							console.warn('Please enable '+ widgetName +' widget in config');
						}

					}
				}, this), 0);

			}, this);

			return this;
		},
		addWidgetRegion: function(){
			var uniq_id = _.uniqueId('widget-');
			this.model.get('widgets').push({id: uniq_id});
			this.model.trigger('change:widgets');
			return uniq_id;
		}

	});

}(window, APP, Backbone, Marionette, $, _));